// 提示音：WebAudio 合成（不依赖音频文件），可循环直到用户处理
let ctx: AudioContext | null = null;
let loop: ReturnType<typeof setInterval> | null = null;

function audio(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

/** 需要用户手势调用一次（「开启提醒」按钮），之后才能自动响 */
export async function unlockAudio(): Promise<boolean> {
  const a = audio();
  if (!a) return false;
  try {
    if (a.state === "suspended") await a.resume();
    return a.state === "running";
  } catch {
    return false;
  }
}

export function audioUnlocked(): boolean {
  return ctx?.state === "running";
}

/** 叮咚：两声上行音 */
export function chime(kind: "scan" | "review" = "scan"): void {
  const a = audio();
  if (!a || a.state !== "running") return;
  const notes = kind === "scan" ? [880, 1175, 880, 1175] : [660, 880];
  const t0 = a.currentTime;
  notes.forEach((freq, i) => {
    const osc = a.createOscillator();
    const gain = a.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    const s = t0 + i * 0.22;
    gain.gain.setValueAtTime(0.0001, s);
    gain.gain.exponentialRampToValueAtTime(0.35, s + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, s + 0.2);
    osc.connect(gain).connect(a.destination);
    osc.start(s);
    osc.stop(s + 0.21);
  });
}

export function startRinging(kind: "scan" | "review"): void {
  stopRinging();
  chime(kind);
  loop = setInterval(() => chime(kind), 2500);
}

export function stopRinging(): void {
  if (loop) clearInterval(loop);
  loop = null;
}
